export default {
  currentProject: {},
};
